export default {
  currentProject: {},
};
